/** Shared ® superscript for LexGat brand marks */
export function LexGatTrademark({
  className = '',
  size = 'text',
}: {
  className?: string;
  size?: 'text' | 'wordmark' | 'icon';
}) {
  const sizeClass =
    size === 'wordmark'
      ? 'text-xs md:text-sm'
      : size === 'icon'
        ? 'text-[10px]'
        : 'text-[0.75em]';

  return (
    <sup
      className={`font-medium leading-none align-super ${sizeClass} ${className}`}
      aria-hidden
    >
      ®
    </sup>
  );
}

/** Full LexGat wordmark (transparent PNG). Use tone="on-light" on pale backgrounds. */
export function LexGatWordmark({
  className = 'h-8 w-auto',
  tone = 'on-dark',
  showTrademark = true,
}: {
  className?: string;
  tone?: 'on-dark' | 'on-light';
  showTrademark?: boolean;
}) {
  const toneClass =
    tone === 'on-light'
      ? 'brightness-0 opacity-100 drop-shadow-none'
      : 'opacity-90 drop-shadow-[0_0_20px_rgba(255,255,255,0.08)]';

  const markColor = tone === 'on-light' ? 'text-zinc-900' : 'text-white';

  return (
    <span className="inline-flex items-center">
      <img
        src="/lexgat-wordmark.png?v=3"
        alt="LexGat"
        className={`block object-contain object-left ${toneClass} ${className}`}
        decoding="async"
      />
      {showTrademark ? (
        <LexGatTrademark size="wordmark" className={`-ml-3 -mt-1 ${markColor}`} />
      ) : null}
    </span>
  );
}
